export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12082.50838d00.jpg";